'use strict';

module.exports = function formatPhoneNumber(inputStr) {
    if (!inputStr) {
        inputStr = "";
    }
    inputStr = inputStr.toString();
    if (inputStr.length === 10) {
        return [
            inputStr.slice(0, 3),
            inputStr.slice(3, 6),
            inputStr.slice(6)
        ].join('-');
    } else {
        return inputStr;
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/dibs-format-phone-number/index.js
// module id = 2803
// module chunks = 63